import React, { FC, useState } from "react";
import { t } from "i18next";
import { FileMetaDataDto } from "@green0meter/api-client";

import { ConfirmationModal } from "../Modals";

import { Button } from "@components/base";
import { useUserStore } from "@store/user";
import { useDeleteUserFile } from "@api";

interface DeleteReportButton {
  report: FileMetaDataDto;
  isBuyer?: boolean;
}

const DeleteReportButton: FC<DeleteReportButton> = ({ report }) => {
  const { user } = useUserStore();
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const { deleteUserFileAsync, deleteUserFileEnabled } = useDeleteUserFile(user);
  const { pathName } = report;

  const handleFileDelete = async (): Promise<void> => {
    setLoading(true);
    try {
      await deleteUserFileAsync(pathName);
      setIsOpen(false);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    deleteUserFileEnabled && (
      <>
        <Button
          key={`${report.fileId}-delete`}
          size="small"
          color="error"
          onClick={() => setIsOpen(true)}
          isLoading={loading}
        >
          {t("common.delete")}
        </Button>
        <ConfirmationModal
          open={isOpen}
          onClose={() => setIsOpen(false)}
          onConfirm={handleFileDelete}
          title={t("common.confirmDelete")}
        />
      </>
    )
  );
};

export default DeleteReportButton;
